const headerNavLinks = [
    { href: '/', title: 'Home' },
    { href: '/about', title: 'About' },
];

export default headerNavLinks;
